import React, { useState, useEffect } from "react";
import {
    Button,
    Col,
    FormGroup,
    Input,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
} from "reactstrap";
import { showMessage, showQuestion } from "services/message.js";
import { CancelarRequerimentoByRequerimento } from "services/requerimento_service.js";
import { useAuth } from "context/auth";

export default function ModalCancelamentoRequerimento({
    visibilidadeModal,
    setVisibilidadeModal,
    item,
    onCancelado,
    onConfirmar,
}) {
    const { session, setLoading } = useAuth();
    const [motivo, setMotivo] = useState("");

    useEffect(() => {
        if (visibilidadeModal) setMotivo("");
    }, [visibilidadeModal]);

    const confirmar = () => {
        if (motivo.trim() === "") {
            showMessage("Atenção", "Informe o motivo do cancelamento!", "warning", null);
            return;
        }

        if (onConfirmar) {
            onConfirmar(motivo, setVisibilidadeModal);
            return;
        }

        showQuestion("Atenção", "Deseja cancelar este requerimento?", "question", function (result) {
            if (result) {
                const usuario_Id =
                    session != null && session.tipoAcesso === "AreaRestrita"
                        ? session.usuario_Id
                        : 0;
                setLoading(true);
                CancelarRequerimentoByRequerimento(
                    item.requerimento_Id,
                    usuario_Id,
                    { justificativaCancelamento: motivo },
                    (res) => {
                        setLoading(false);
                        setVisibilidadeModal();
                        showMessage(
                            "Aviso",
                            "Requerimento cancelado com sucesso!",
                            "success",
                            function () {
                                if (onCancelado) onCancelado(res);
                                else window.location.reload();
                            }
                        );
                    }
                );
            }
        });
    };

    return (
        <Modal isOpen={visibilidadeModal} centered toggle={setVisibilidadeModal}>
            <ModalHeader
                close={<button className="close" onClick={setVisibilidadeModal}>&times;</button>}
                className="md-hd"
                style={{ backgroundColor: "#fff3cd" }}
            >
                Cancelamento de Requerimento
            </ModalHeader>
            <ModalBody className="md-bd">
                <Row>
                    <Col md="12">
                        <label>Informe a justificativa do cancelamento do requerimento.</label>
                    </Col>
                    <Col md="12">
                        <FormGroup>
                            <b>
                                <label>
                                    Justificativa do Cancelamento{" "}
                                    <span className="text-danger">*</span>
                                </label>
                            </b>
                            <Input
                                type="textarea"
                                name="motivoCancelamento"
                                value={motivo}
                                onChange={(e) => setMotivo(e.target.value)}
                                placeholder="Digite o motivo do cancelamento"
                                rows="5"
                                maxLength="300"
                            />
                            {motivo.trim() === "" && (
                                <span className="form-control-label text-danger">
                                    * Campo Obrigatório
                                </span>
                            )}
                        </FormGroup>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter className="md-ft">
                <Row>
                    <Col md="12">
                        <Button color="secondary" className="btn-mobile" onClick={setVisibilidadeModal}>
                            Cancelar
                        </Button>
                        <Button
                            color="danger"
                            className="btn-mobile"
                            type="submit"
                            onClick={confirmar}
                        >
                            <i className="fas fa-check"></i> Confirmar Cancelamento
                        </Button>
                    </Col>
                </Row>
            </ModalFooter>
        </Modal>
    );
}
